import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/lockAction.svg?url_encode")